import React from "react";
import FormLayout from '../FormLayout';
import TextField from './TextField';
import CountriesField from '../../components/CountriesField';
import { getDataSet, reduce } from 'iso3166-2-db';

const EXTRA_COUNTRIES = {
    XK: { name: 'Kosovo' },
};

/** Countries (ISO codes); same component as the movie event “country” field. */
class CountriesFormField extends TextField {

    constructor(properties) {
        super({
            ...(CountriesFormField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.COUNTRIES;
    }

    static getDefaultOptions() {
        const properties = super.getDefaultOptions();
        const existing = properties.content && typeof properties.content === 'object' ? properties.content : {};
        const defaults = Array.isArray(existing.defaults) ? existing.defaults : [];
        properties.content = { ...existing, defaults };
        properties.multiple = !!properties.multiple;

        return properties;
    }

    getHandledOptions() {
        return super.getHandledOptions()
            .filter(o => o !== FormLayout.OPTION_PLACEHOLDER)
            .concat([
                FormLayout.OPTION_MULTIPLE,
                FormLayout.OPTION_DEFAULTS,
            ]);
    }

    getFormInitialValue() {
        const raw = this.content?.defaults;
        if (!raw || !Array.isArray(raw) || raw.length === 0) {
            return undefined;
        }
        const codes = raw.map(String).filter(Boolean);
        if (!codes.length) {
            return undefined;
        }
        if (this.multiple) {
            return codes;
        }
        return codes[0];
    }

    getInput(props) {
        return <CountriesField name={this.reduxFieldName(props)} single={!this.multiple} />;
    }

    renderValue(value, context) {
        if (value == null || value === '')
            return super.renderValue(value, context);
        const codes = Array.isArray(value) ? value : [value];
        const lang = (context?.lang || 'fr').substring(0, 2);
        const countries = {
            ...reduce(getDataSet(), lang),
            ...EXTRA_COUNTRIES,
        };
        return codes
            .map(code => countries[code]?.name || code)
            .join(', ');
    }

    getIcon() {
        return 'flag';
    }
}

export default CountriesFormField;
